export const jobs = [
  {text: 'ACCOUNTING', value:'ACCOUNTING'},
  {text: 'AIR_TRANSPORTATION', value:'AIR_TRANSPORTATION'},
  {text: 'ARCHITECT', value:'ARCHITECT'},
  {text: 'ARTIST', value:'ARTIST'},
  {text: 'BREEDER', value:'BREEDER'},
  {text: 'BROKER', value:'BROKER'},
  {text: 'CHEF', value:'CHEF'},
  {text: 'CONSULTANT', value:'CONSULTANT'},
  {text: 'CRAFTSMAN', value:'CRAFTSMAN'},
  {text: 'CUSTOMER_SERVICE', value:'CUSTOMER_SERVICE'},
  {text: 'DESIGNER', value:'DESIGNER'},
  {text: 'DISTRIBUTOR', value:'DISTRIBUTOR'},
  {text: 'DOCTOR', value:'DOCTOR'},
  {text: 'ENGINEER', value:'ENGINEER'},
  {text: 'ENTREPRENEUR', value:'ENTREPRENEUR'},
  {text: 'EXECUTIVE', value:'EXECUTIVE'},
  {text: 'FARMER', value:'FARMER'},
  {text: 'FISHERMAN', value:'FISHERMAN'},
  {text: 'GENERAL_ADMINISTRATION', value:'GENERAL_ADMINISTRATION'},
  {text: 'GOVERNMENT_EMPLOYEE', value:'GOVERNMENT_EMPLOYEE'},
  {text: 'HOUSEWIFE', value:'HOUSEWIFE'},
  {text: 'INFORMAL_WORKERS', value:'INFORMAL_WORKERS'},
  {text: 'LABOR', value:'LABOR'},
  {text: 'LAND_TRANSPORTATION', value:'LAND_TRANSPORTATION'},
  {text: 'LAWYER', value:'LAWYER'},
  {text: 'MARKETING', value:'MARKETING'},
  {text: 'MEDICAL_PERSONNEL', value:'MEDICAL_PERSONNEL'},
  {text: 'MILITARY', value:'MILITARY'},
  {text: 'OTHER', value:'OTHER'},
  {text: 'POLICE', value:'POLICE'},
  {text: 'RESEARCHER', value:'RESEARCHER'},
  {text: 'RETIRED', value:'RETIRED'},
  {text: 'SEA_TRANSPORTATION', value:'SEA_TRANSPORTATION'},
  {text: 'SECURITY', value:'SECURITY'},
  {text: 'SELF_EMPLOYED', value:'SELF_EMPLOYED'},
  {text: 'STATE_OFFICIALS', value:'STATE_OFFICIALS'},
  {text: 'STUDENT', value:'STUDENT'},
  {text: 'TEACHER', value:'TEACHER'},
  {text: 'WAITER', value:'WAITER'}
]

export const relations = [
    {text: 'PARENT', value: 'PARENT'},
    {text: 'SPOUSE', value: 'SPOUSE'},
    {text: 'RELATIVE', value: 'RELATIVE'},
    {text: 'FRIEND', value: 'FRIEND'},
    {text: 'CLASSMATE', value: 'CLASSMATE'},
    {text: 'COLLEAGUE', value: 'COLLEAGUE'},
]

export const genders = [
  {
    label: "MALE",
    value: "MALE"
  },
  {
    label: "FEMALE",
    value: "FEMALE"
  }
];

export const eductions = [
  {text: 'MASTER_PHD', value: 'MASTER_PHD'},
  {text: 'COLLEGE_GRADUATE', value: 'COLLEGE_GRADUATE'},
  {text: 'HIGH_SCHOOL', value: 'HIGH_SCHOOL'},
  {text: 'PRIMARY_SCHOOL', value: 'PRIMARY_SCHOOL'},
  {text: 'NONE', value: 'NONE'},
]

export const marryOptions = [
  { text: "MARRIED", value: "MARRIED" },
  { text: "SINGLE", value: "SINGLE" },
  { text: "DIVORCED", value: "DIVORCED" },
  { text: "OTHER", value: "WIDOWED" }
];

export const purposes = [
  { text: "Giáo dục", value: "Education" },
  { text: "Hàng tiêu dùng", value: "Consumer goods" },

  { text: "Kinh doanh", value: "Business" },
  { text: "Y khoa", value: "Medical" },
  { text: "Khác", value: "Other" }
];

export const years = [
  { value: "THREE_MONTH", text: "3 Tháng" },
  { value: "SIX_MONTH", text: "6 Tháng" },
  { value: "ONE_YEAR", text: "1 Năm" },
  { value: "TWO_YEAR", text: "2 Năm" },
  { value: "OVER_TWO_YEAR", text: "> 2 Năm" }
];

export const childrenOptions = [
  { value: "ZERO", text: "0" },
  { value: "ONE", text: "1" },
  { value: "TWO", text: "2" },
  { value: "THREE", text: "3" },
  { value: "FOUR", text: "4" },
  { value: "OVER_FOUR", text: ">4" }
];

export const incomes = [
  { text: 'PH_6000_OR_BELOW', value: "Below 6000" },
  { text: 'PH_6001_10000', value: "Between 6000 and 10000" },
  { text: 'PH_10001_15000', value: "Between 10000 and 15000" },
  { text: 'PH_15001_20000', value: "Between 15000 and 20000" },
  { text: 'PH_20001_30000', value: "Between 20000 and 30000" },
  { text: 'PH_30001_AND_ABOVE', value: "Above 30000" },
]
export const drawChannel = ["BANK","GCASH","PAYMAYA","GRABPAY"]

// 需要还款的贷款状态
export const showRepaymentStatus = ["CURRENT", "OVERDUE", "GRACE_PERIOD", "BAD_DEBIT"];
